import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/arrow-back.svg'


const _withScopeId = n => (_pushScopeId("data-v-304f7422"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "div-content" }
const _hoisted_2 = { class: "div-appointment content" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "icon-darker-return",
  src: _imports_0
}, null, -1))
const _hoisted_4 = { id: "category-h1" }
const _hoisted_5 = {
  key: 0,
  id: "category-descrption-sub"
}
const _hoisted_6 = {
  key: 1,
  id: "category-descrption-sub"
}
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { class: "div-content div-services" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_category_service_primary_and_control = _resolveComponent("category-service-primary-and-control")!
  const _component_category_service_other_specialists = _resolveComponent("category-service-other-specialists")!
  const _component_category_service_health_and_welfare = _resolveComponent("category-service-health-and-welfare")!
  const _component_category_service_imaging = _resolveComponent("category-service-imaging")!
  const _component_category_service_endoscopy = _resolveComponent("category-service-endoscopy")!
  const _component_category_service_early_detection = _resolveComponent("category-service-early-detection")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h3", {
          id: "category-return-h3",
          class: "clickable",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toAllCategories && _ctx.toAllCategories(...args)))
        }, [
          _hoisted_3,
          _createTextVNode(" " + _toDisplayString(_ctx.store.getters.translate("category-subtitle-return")), 1)
        ]),
        _createElementVNode("h1", _hoisted_4, _toDisplayString(_ctx.store.getters.translate("category-title")), 1),
        (_ctx.backend.isLoggedIn())
          ? (_openBlock(), _createElementBlock("sub", _hoisted_5, _toDisplayString(_ctx.store.getters.translate("category-description-logged-in")), 1))
          : (_openBlock(), _createElementBlock("sub", _hoisted_6, [
              (_ctx.store.getters.isAcuteActive)
                ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_ctx.store.getters.translate("category-description")), 1))
                : (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_ctx.store.getters.translate("category-description-mehilainen")), 1))
            ]))
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      (_ctx.isCategoryPrimaryAndControl())
        ? (_openBlock(), _createBlock(_component_category_service_primary_and_control, {
            key: 0,
            onServiceSelected: _ctx.serviceSelected
          }, null, 8, ["onServiceSelected"]))
        : _createCommentVNode("", true),
      (_ctx.isCategoryOtherSpecialists())
        ? (_openBlock(), _createBlock(_component_category_service_other_specialists, {
            key: 1,
            onServiceSelected: _ctx.serviceSelected
          }, null, 8, ["onServiceSelected"]))
        : _createCommentVNode("", true),
      (_ctx.isCategoryHealthAndWelfare())
        ? (_openBlock(), _createBlock(_component_category_service_health_and_welfare, {
            key: 2,
            onServiceSelected: _ctx.serviceSelected
          }, null, 8, ["onServiceSelected"]))
        : _createCommentVNode("", true),
      (_ctx.isCategoryImaging())
        ? (_openBlock(), _createBlock(_component_category_service_imaging, {
            key: 3,
            onServiceSelected: _ctx.serviceSelected
          }, null, 8, ["onServiceSelected"]))
        : _createCommentVNode("", true),
      (_ctx.isCategoryEndoscopy())
        ? (_openBlock(), _createBlock(_component_category_service_endoscopy, {
            key: 4,
            onServiceSelected: _ctx.serviceSelected
          }, null, 8, ["onServiceSelected"]))
        : _createCommentVNode("", true),
      (_ctx.isCategoryEarlyDetection())
        ? (_openBlock(), _createBlock(_component_category_service_early_detection, {
            key: 5,
            onServiceSelected: _ctx.serviceSelected
          }, null, 8, ["onServiceSelected"]))
        : _createCommentVNode("", true)
    ])
  ], 64))
}